import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FB_LOGIN_FAVORITES } from 'commons/constants';
import { logError } from 'commons/logger';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import { setItemInStorage, removeItemInStorage } from 'commons/localStorage';
import browserStorage from '../browser-storage';
const FavoriteViewModal = t0 => {
  const $ = _c(22);
  const {
    optionValueId: t1,
    onClose,
    productId,
    productName,
    swatchOption,
    isSideBarVisible: t2
  } = t0;
  const optionValueId = t1 === undefined ? null : t1;
  const isSideBarVisible = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isSideBarVisible || $[1] !== optionValueId || $[2] !== productId) {
    t3 = () => {
      if (isSideBarVisible && !optionValueId) {
        setItemInStorage(FB_LOGIN_FAVORITES, {
          productID: productId
        });
      }
    };
    $[0] = isSideBarVisible;
    $[1] = optionValueId;
    $[2] = productId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isSideBarVisible || $[5] !== optionValueId || $[6] !== productId || $[7] !== productName || $[8] !== swatchOption) {
    t4 = [isSideBarVisible, optionValueId, productId, productName, swatchOption];
    $[4] = isSideBarVisible;
    $[5] = optionValueId;
    $[6] = productId;
    $[7] = productName;
    $[8] = swatchOption;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== onClose) {
    t5 = async () => {
      ;
      try {
        onClose();
        browserStorage().removeItem("favoriteClickedProduct");
        removeItemInStorage(FB_LOGIN_FAVORITES);
      } catch (t6) {
        const e = t6;
        logError(e);
      }
    };
    $[10] = onClose;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isSideBarVisible || $[13] !== onClose || $[14] !== productName || $[15] !== t5) {
    t6 = {
      show: isSideBarVisible,
      wishListProduct: productName,
      onClose,
      onLogin: t5
    };
    $[12] = isSideBarVisible;
    $[13] = onClose;
    $[14] = productName;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let loginSidebarProps = t6;
  if (optionValueId) {
    let t7;
    if ($[17] !== isSideBarVisible || $[18] !== onClose) {
      t7 = {
        show: isSideBarVisible,
        onClose
      };
      $[17] = isSideBarVisible;
      $[18] = onClose;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    loginSidebarProps = t7;
  }
  let t7;
  if ($[20] !== loginSidebarProps) {
    t7 = <LoginSidebar {...loginSidebarProps} />;
    $[20] = loginSidebarProps;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
FavoriteViewModal.propTypes = {
  optionValueId: PropTypes.number,
  onClose: PropTypes.func,
  productId: PropTypes.number,
  productName: PropTypes.string,
  swatchOption: PropTypes.object,
  isSideBarVisible: PropTypes.bool
};
export default FavoriteViewModal;